import { useState } from 'react';
import { IUserPlanState } from '@/creditflowresearch/application/User/UserPlan/types';
import { initUserPlan } from '@/creditflowresearch/application/User/UserPlan/initialState';
import { useFetchUserPlan } from '@/creditflowresearch/application/User/UserPlan/hooks/useFetchUserPlan';
import { useUserPlanPreferences } from '@/creditflowresearch/application/User/UserPlan/hooks/useUserPlanPreferences';
import { useUserPlanAccess } from '@/creditflowresearch/application/User/UserPlan/hooks/useUserPlanAccess';

export const useUserPlanState = (initial: IUserPlanState) => {
  const [currentPlan, setCurrentPlan] = useState<IUserPlanState>(initial);

  const { getUserPlan } = useFetchUserPlan(currentPlan, setCurrentPlan, initial);

  const { preferences, hasSavedPreferences, setUserPlanPreferences } = useUserPlanPreferences(
    currentPlan,
    setCurrentPlan,
  );

  const {
    isUnauthorized,
    isStarter,
    isPro,
    isPremium,
    checkAccessByUserPlan,
    checkAccessByFeature,
  } = useUserPlanAccess(currentPlan);

  return {
    ...(currentPlan || initUserPlan),
    preferences,
    hasSavedPreferences,
    isUnauthorized,
    isStarter,
    isPro,
    isPremium,
    getUserPlan,
    checkAccessByUserPlan,
    checkAccessByFeature,
    setUserPlanPreferences,
  };
};
